<template>
	<div class="container-large pb-4">
		<div
			class="col-12 d-flex flex-column align-items-center justify-content-center"
		>
			<div class="col-12 px-0 col-lg-8">
				<div class="col-12">
					<div
						class="col-12 px-0 print-d-none d-block pb-4 text-md-center pr-6 pr-md-0"
					>
						<span> {{ label }} </span>
						<h4 class="font-24 font-md-32 m-0">
							CONFIRA AS INFORMAÇÕES
						</h4>
					</div>
					<div class="print-d-block text-center">
						<div class="mb-5">
							<img
								:src="account_logo"
								style="
									height: 100px;
									position: relative;
									top: 8px;
								"
							/>
						</div>
						<h5>{{ label }}</h5>
						<h3>{{ requester_selected_object.requester.name }}</h3>
					</div>
				</div>
				<scheduling-card
					:type="'scheduling'"
					:scheduling_base="scheduling"
					@update-obs="FillObs"
				/>
			</div>

			<PaymentMethodsModal
				v-if="time.schedule?.continua || type == 'fit'"
				:total="total_proceedings"
				@payment-methods-added="PaymentMethodsHandler"
			/>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	import { mapGetters, mapActions } from 'vuex'

	import PaymentMethodsModal from '@/components/shared/payment/PaymentMethodsModal.vue'
	import SchedulingCard from '@/components/search/SchedulingCard.vue'

	export default {
		name: 'Confirm',
		components: {
			PaymentMethodsModal,
			SchedulingCard,
		},
		props: {
			label: {
				type: String,
				default: '',
			},
			origin: {
				type: Number,
				default: 2,
			},
			module_id: {
				type: [String, Number],
				default: null,
			},
			modality_id: {
				type: [String, Number],
				default: null,
			},
			journey_id: {
				type: [String, Number],
				default: null,
			},
			patient: {
				type: Object,
				default: null,
			},
			partnership: {
				type: Object,
				default: null,
			},
			time: {
				type: Object,
				default: null,
			},
			proceedings: {
				type: Array,
				default: null,
			},
			classification: {
				type: [Number, String],
				default: '',
			},
			billing: {
				type: Object,
				default: null,
			},
			indicator: {
				type: Object,
				default: () => {},
			},
			type: {
				type: String,
				default: 'scheduling',
			},
			printStatement: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				ORIGINS: {
					SCHEDULING_PRE_APPOINTMENT: 2,
					SCHEDULING_URGENT_APPOINTMENT: 3,
					FIT: 4,
				},
				places: [],
				form: {
					place_id: null,
					telefone_1: '',
					obs: '',
				},
				payment_methods_info: null,
				attemptedSubmit: false,
				defaultAvatar: window.defaultAvatar,
				group_instructions: [],
				subgroup_instructions: [],
			}
		},
		watch: {
			patient: {
				handler(val) {
					if (val.telefone) {
						const telefone_1 = JSON.parse(
							val.telefone.replace(/\\/g, '')
						)[0]

						this.form.telefone_1 = telefone_1
					}
				},
				immediate: true,
				deep: true,
			},
			proceedings: {
				async handler() {
					const { group_instructions, subgroup_instructions } =
						await this.GetGroupAndSubgroupInstructions()
					this.group_instructions = group_instructions
					this.subgroup_instructions = subgroup_instructions
				},
				immediate: true,
				deep: true,
			},
		},
		computed: {
			...mapGetters('system', ['modules', 'modalities']),
			...mapGetters('auth', [
				'requester_selected_object',
				'requester_selected_id',
			]),
			selected_place_name() {
				const place = this.places.find(p => p.id === this.form.place_id)

				return place ? place.endereco : 'Não há'
			},
			selected_module() {
				const module = this.modules.find(
					m => m.id === parseInt(this.module_id)
				)

				return module
			},
			selected_modality() {
				const modality = this.modalities.find(
					m => m.id === parseInt(this.modality_id)
				)

				return modality
			},
			account_logo() {
				const vm = this

				return vm.requester_selected_object.instance.config.logo_url
			},
			has_instruction() {
				const vm = this

				return vm.proceedings.filter(p => p.instructions).length
			},
			patient_age() {
				if (this.patient && this.patient.data_nascimento) {
					const dob = moment(
						this.patient.data_nascimento,
						'YYYY-MM-DD'
					)
					const today = moment()

					const years = today.diff(dob, 'year')
					dob.add(years, 'years')

					const months = today.diff(dob, 'months')
					dob.add(months, 'months')

					const days = today.diff(dob, 'days')

					let result = ''

					if (years > 0) {
						result = `${years} ANO${years > 1 ? 'S' : ''} `
					} else if (years === 0 && months > 0) {
						result = `${months} MES${
							months > 1 ? 'ES' : ''
						} e ${days} DIA${days > 1 ? 'S' : ''}`
					} else if (months === 0 && days > 0) {
						result = `${days} DIA${days > 1 ? 'S' : ''} `
					} else {
						result = '0 DIAS'
					}

					return result
				} else {
					return 'DESCONHECIDO'
				}
			},
			scheduling() {
				const vm = this

				const obj = {
					header: {},
					intake_form: {
						origin: vm.origin,
						module: vm.selected_module.name,
						modality: vm.selected_modality.name,
						indicator: vm.indicator?.name.toUpperCase(),
						data: vm.time.dia,
						hora: vm.time.hora,
						obs: vm.form.obs.length ? vm.form.obs : null,
					},
				}

				if (vm.origin !== vm.ORIGINS.SCHEDULING_PRE_APPOINTMENT) {
					obj.intake_form.data = moment().format('YYYY-MM-DD')
					obj.intake_form.hora = moment().format('HH:mm:ss')
				}

				obj.intake_form.scheduling_date_time =
					obj.intake_form.data + ' ' + obj.intake_form.hora

				const patient_cellphone = vm.patient.telefone
					? JSON.parse(vm.patient.telefone)[0]
					: null

				obj.header.patient = {
					...vm.patient,
					name:
						vm.patient.nome_social?.toUpperCase() ||
						vm.patient.nome_paciente?.toUpperCase(),
					mother_name: vm.patient.nome_mae?.toUpperCase(),
					rg: vm.patient.rg,
					rg_uf: vm.patient.rg_uf,
					cpf: vm.patient.cpf,
					sus: vm.patient.sus,
					rh: vm.patient.rh,
					date_of_birth: vm.patient.data_nascimento,
					sex: vm.patient.sexo?.toUpperCase(),
					cellphone: patient_cellphone,
					patient_code: vm.patient.patient_code,
				}

				obj.header.partnership = vm.partnership.nome

				obj.header.indicator = vm.indicator?.name ?? null

				const schedule = vm.time.schedule
					? { ...vm.time.schedule }
					: { ...vm.time }

				obj.intake_form.schedule = {
					...schedule,
					name: schedule.nome,
				}

				obj.intake_form.proceedings = vm.proceedings.map(p => {
					return {
						...p,
						name: p.nome,
						instructions: p.instructions,
					}
				})

				obj.intake_form.organization_instructions =
					vm.requester_selected_object?.instance?.config?.instructions
				obj.intake_form.module_instructions =
					vm.selected_module.instructions
				obj.intake_form.modality_instructions =
					vm.selected_modality.instructions
				obj.intake_form.group_instructions = vm.group_instructions
				obj.intake_form.subgroup_instructions = vm.subgroup_instructions

				return obj
			},
			total_proceedings() {
				let value = 0

				if (!this.proceedings.length) return value

				value = this.proceedings.reduce((acc, proceeding) => {
					return (
						acc + Number(proceeding?.partnerships[0]?.pivot?.valor)
					)
				}, 0)

				return value
			},
			compiled_instructions() {
				const vm = this
				let instructions = ''
				let isFirst = true

				const buildBlock = content => {
					const hr = isFirst
						? ''
						: '<hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;"/>'
					isFirst = false
					return `<div class="col-12 text-dark instructions-list"><div class="col-12 p-0 instruction-item">${hr}<div class="mb-0 h6-size">${content}</div></div></div>`
				}

				const orgInstructions =
					vm.requester_selected_object?.instance?.config?.instructions
				if (orgInstructions) {
					instructions += buildBlock(orgInstructions)
				}

				const moduleInstructions = vm.selected_module?.instructions
				if (moduleInstructions) {
					instructions += buildBlock(moduleInstructions)
				}

				const modalityInstructions = vm.selected_modality?.instructions
				if (modalityInstructions) {
					instructions += buildBlock(modalityInstructions)
				}

				const groupsMap = new Map()
				const subgroupsMap = new Map()

				if (vm.group_instructions?.length) {
					vm.group_instructions.forEach(g => {
						if (g && g.id) groupsMap.set(g.id, g)
					})
				}

				if (vm.subgroup_instructions?.length) {
					vm.subgroup_instructions.forEach(s => {
						if (s && s.id) subgroupsMap.set(s.id, s)
					})
				}

				const hierarchy = new Map()

				vm.proceedings.forEach(proc => {
					const subgroupId = proc.parent_id
					const subgroup = subgroupsMap.get(subgroupId)
					const groupId = subgroup?.parent_id || null
					const group = groupsMap.get(groupId)

					const groupKey = groupId || 'no-group'
					const subgroupKey = subgroupId || 'no-subgroup'

					if (!hierarchy.has(groupKey)) {
						hierarchy.set(groupKey, {
							group: group,
							subgroups: new Map(),
						})
					}

					const groupEntry = hierarchy.get(groupKey)

					if (!groupEntry.subgroups.has(subgroupKey)) {
						groupEntry.subgroups.set(subgroupKey, {
							subgroup: subgroup,
							proceedings: [],
						})
					}

					groupEntry.subgroups.get(subgroupKey).proceedings.push(proc)
				})

				hierarchy.forEach(groupEntry => {
					if (groupEntry.group && groupEntry.group.instructions) {
						instructions += buildBlock(
							groupEntry.group.instructions
						)
					}

					groupEntry.subgroups.forEach(subgroupEntry => {
						if (
							subgroupEntry.subgroup &&
							subgroupEntry.subgroup.instructions
						) {
							instructions += buildBlock(
								subgroupEntry.subgroup.instructions
							)
						}

						subgroupEntry.proceedings.forEach(proc => {
							if (proc && proc.instructions) {
								instructions += buildBlock(proc.instructions)
							}
						})
					})
				})

				return instructions
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			FormatFullDate(value, fmt) {
				const m = moment(value, 'YYYY-MM-DD HH:mm:ss')

				return m.format(fmt)
			},
			Previous() {
				this.$emit('previous')
			},
			GetAvatar(path) {
				return path ? path : '/img/profile.png'
			},
			GetClassification() {
				const classification = window.classifications.find(
					c => c.value == parseInt(this.classification)
				)
				return classification.text
			},
			Continue() {
				const place = this.places.find(p => p.id == this.form.place_id)

				this.$emit('next', {
					obs: this.form.obs,
					place: place,
					payment_methods_info: this.payment_methods_info,
					instructions: this.compiled_instructions,
				})
			},
			FillObs(obs) {
				this.form.obs = obs
			},
			OpenModal(id) {
				window.jQuery(id).modal('show')
			},
			PaymentMethodsHandler(payment_methods_info) {
				this.payment_methods_info = payment_methods_info
			},
			async GetGroupAndSubgroupInstructions() {
				const parentIds = [
					...new Set(
						this.proceedings
							.map(p => p.parent_id)
							.filter(id => id !== null && id !== undefined)
					),
				]

				if (parentIds.length === 0) {
					return { group_instructions: [], subgroup_instructions: [] }
				}

				const { data } = await window.api.call(
					'post',
					'/get-proceedings-instructions',
					{
						organization_id: this.requester_selected_id,
						parent_ids: parentIds,
					}
				)

				if (data.response) {
					return {
						group_instructions: data.group_instructions || [],
						subgroup_instructions: data.subgroup_instructions || [],
					}
				}

				return { group_instructions: [], subgroup_instructions: [] }
			},
		},
		mounted() {
			const style_print = window.jQuery('<link>', {
				rel: 'stylesheet',
				type: 'text/css',
				href: require('@/assets/sass/portrait.scss'),
			})

			style_print.appendTo('head')
		},
	}
</script>

<style lang="css" scoped>
	.patient-button {
		width: 160px;
		height: 160px;
	}

	.patient-button i {
		font-size: 3rem;
	}

	@media print {
		.print-d-none,
		.overlay-loading,
		.swal2-container {
			display: none !important;
		}

		.text-dark,
		.h1,
		.h2,
		.h3,
		.h4,
		.h5,
		.h6,
		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			color: #212529 !important;
		}

		.container hr {
			margin: 0.2rem 0;
		}

		button {
			display: none !important;
		}

		body {
			background-color: #fff !important;
			color: #212529 !important;
		}

		body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)
			> [aria-hidden='true'],
		.print-d-block {
			display: block !important;
		}

		header {
			display: none !important;
		}
	}

	.p-m-0 p {
		margin: 0;
	}

	#remove-indicator {
		cursor: pointer;
	}

	.border-danger {
		border: 2px solid red;
	}
</style>
